export default {
  namespaced: true,

  state: {
    item: null
  },

  getters: {
    globalDiscountCode: (state) => state.item
  },

  mutations: {
    newDiscount: (state, discount) => {
      state.item = discount
    },

    resetState(state) {
      state.item = null
    }
  },

  actions: {
    setDiscount({ commit }, discountCode) {
      commit('newDiscount', discountCode)
    }
  }
}
